import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { UIHelpers } from '../../../constants/pages/UIHelpers';
import { useFunctionalitiesUIContext } from '../context/ConsultantsUIContext';
import { Stack } from '@mui/material';
import { HeaderTitle, MenuSVG, Table } from '../../../components';
import { CardBody } from 'reactstrap';

// import moment from 'moment';
// import { checkFileStatus } from '../../../helpers/fibonacciHelper';
// import { reportsService, usersService } from '../../../services';
import { usersService } from '../../../services';
import { FilterQueryParams } from '../../../helpers';
// import axios from 'axios';
// import { downloadCSV } from '../../../helpers/download';
import { connect } from 'react-redux';
import consultantsColumns from './ConsultantsColumns';
import page from '../../../constants/pages/page';
import { useHistory } from 'react-router-dom';
import ConsultantsFilters from './ConsultantsFilters';
import { checkPermissions } from '../../../helpers/PermissionsChecker';
import CustomAlert from '../../../components/Alert';
import { ROUTES } from '../../../constants/routes/routes';
const TOTAL_CONSULTANTS_PAGE_SIZE = 100000;

function ConsultantsTable () {
    const { t } = useTranslation();
    const history = useHistory();

    const customSortedKeyMap = { id: 'id' };
    const { defaultSorted } = UIHelpers(customSortedKeyMap);
    const consultantsFiltersRef = useRef();

    // State

    // Context State
    const consultantsUIContext = useFunctionalitiesUIContext();
    const consultantsUIProps = useMemo(() => {
        return {
            isLoading: consultantsUIContext.isLoading,
            setIsLoading: consultantsUIContext.setIsLoading,
            queryParams: consultantsUIContext.queryParams,
            setQueryParams: consultantsUIContext.setQueryParams,
            consultants: consultantsUIContext.consultants,
            setConsultants: consultantsUIContext.setConsultants,
        };
    }, [consultantsUIContext]);

    // Alert states
    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: '',
    });
    const [openAlert, setOpenAlert] = useState(false);
    const [totalConsultants, setTotalConsultants] = useState(0);

    // Functions

    const fetchTotalConsultants = async () => {
        const filter =
            consultantsUIProps.queryParams.filters || new FilterQueryParams();
        const options = {
            pageSize: TOTAL_CONSULTANTS_PAGE_SIZE,
            filters: filter.build(),
        };

        try {
            const consultants = await usersService.getConsultants(options);
            setTotalConsultants(Array.isArray(consultants) ? consultants.length : 0);
        }
        catch (error) {
            setTotalConsultants(0);
        }
    };

    const fetchConsultants = async () => {
        // change state isLoading
        consultantsUIProps.setIsLoading(true);
        // prepare options (order, pages and filters)
        const filter =
          consultantsUIProps.queryParams.filters || new FilterQueryParams();
        const { sortOrder, pageSize, pageNumber } = consultantsUIProps.queryParams;
        const options = {
            with: 'attributes',
            order: `id-${sortOrder.toUpperCase()}`,
            pageSize: pageSize,
            page: pageNumber,
            filters: filter.build(),
        };

        try {
            const consultants = await usersService.getConsultants(options);
            const consultantsList = Array.isArray(consultants) ? consultants : [];

            consultantsUIProps.setConsultants(consultantsList);

            if (pageNumber === 1 && consultantsList.length < pageSize) {
                setTotalConsultants(consultantsList.length);
            }
            else {
                await fetchTotalConsultants();
            }
        }
        catch (error) {
            consultantsUIProps.setConsultants([]);
            setTotalConsultants(0);
            setAlert((prevAlert) => ({
                ...prevAlert,
                severity: 'error',
                title: t('errors.generalTitle'),
                description: t('errors.generalDescription'),
                className: 'clientsMC_Alert--error',
            }));
            setOpenAlert(true);
        }
        finally { consultantsUIProps.setIsLoading(false); }
    };

    const getData = async () => {
        fetchConsultants();
    };

    // Handle query params changes. On any param change, fetch users.
    useEffect(
        () =>
            consultantsUIProps.setQueryParams((prev) => ({
                ...prev,
                pageSize: localStorage.getItem('sizePerPage') || page.pageSize,
            }))
        ,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
    useEffect(() => {
        if (JSON.stringify(consultantsUIProps.queryParams.url) !== undefined) {
            getData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consultantsUIProps.queryParams]);

    // TODO carry out NAT-[whichever card ID implements the download function]

    // const getDownloadFilters = () => {
    //     if (!JSON.stringify(consultantsUIProps?.queryParams?.filters?.filters)) { return ''; }
    //     const filters = { ...consultantsUIProps?.queryParams?.filters?.filters };
    //     delete filters.created_at;
    //     return JSON.stringify(filters)
    //         .replace(/[{}"]/g, '')
    //         .replace(/:/g, ' ')
    //         .replace(replaceCommaPattern, replaceComma);
    // };
    // const replaceCommaPattern = /\[([^,]+),([^,\]]+)\]/;
    // const replaceComma = (match, p1, p2) => {
    //     return `[${p1};${p2}]`;
    // };

    // const download = async () => {
    //     consultantsUIProps.setIsLoading(true);

    //     const fetchFile = (idFile) => {
    //         return checkFileStatus({ filters: `id eq ${idFile}` }, 60, 3);
    //     };
    //     const startDate =
    //   consultantsUIProps.queryParams?.filters?.filters?.created_at?.be[0] ||
    //   moment()
    //       .subtract(730, 'days')
    //       .format('YYYY-MM-DD HH:mm:ss');
    //     const endDate =
    //   consultantsUIProps.queryParams?.filters?.filters?.created_at?.be[1] ||
    //   moment().utc().format('YYYY-MM-DD HH:mm:ss');
    //     const filters =
    //   (consultantsUIProps.queryParams?.filters?.filters?.created_at?.be[0]
    //       ? `created_at be [${startDate};${endDate}]`
    //       : '') +
    //   (consultantsUIProps.queryParams?.filters?.filters?.created_at?.be[0] &&
    //   getDownloadFilters()
    //       ? `,${getDownloadFilters()}`
    //       : getDownloadFilters() || '');
    //     const options = {
    //         idType: 30, // id report of consultants links table
    //         startAt: startDate || '2023-08-21 06:00:00',
    //         endAt: endDate,
    //         metadata: {
    //             filters: filters,
    //             order: 'id-DESC',
    //         },
    //     };
    //     const nameTable = window.location.pathname.slice(
    //         1,
    //         window.location.pathname.length
    //     );
    //     const fileName = startDate
    //         ? `Reporte del ${options.startAt} al ${moment().format('YYYY-MM-DD HH:mm:ss')} ${nameTable}.csv`
    //         : `Reporte ${nameTable}.csv`;
    //     await reportsService
    //         .createReport(options)
    //         .then(async (response) => {
    //             return await fetchFile(response.metadata.id_file);
    //         })
    //         .then(async (res) => {
    //             return await axios.get(res[0].description, {
    //                 responseType: 'arraybuffer',
    //             });
    //         })
    //         .then((response) => {
    //             downloadCSV(response.data, fileName);
    //             consultantsUIProps.setIsLoading(false);
    //         })
    //         .catch(() => {
    //             consultantsUIProps.setIsLoading(false);
    //             setAlert((prevAlert) => ({
    //                 ...prevAlert,
    //                 severity: 'error',
    //                 title: t('errors.generalTitle'),
    //                 description: t('errors.downloadFile'),
    //                 className: 'clientsMC_Alert--error',
    //             }));
    //             setOpenAlert(true);
    //         });
    // };

    const resetFilters = () => {
        if (consultantsFiltersRef.current) {
            consultantsFiltersRef.current.reset();
        }
    };

    // Main Component

    return (
        <>
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />
            <Stack gap={'16px'}>
                <HeaderTitle
                    title={t('management.consultants.table.title')}
                    total={totalConsultants}
                    reset={resetFilters}
                    buttonText={t('management.consultants.loadButton')}
                    handleOnClick={checkPermissions('consultants.load') && (() => { history.push(ROUTES.MANAGEMENT.CONSULTANTS_LOAD); })}
                    icon={<MenuSVG className="mr-1 mb-2" />}
                    UIProps={consultantsUIProps}
                    margBottom={'1rem'}
                />
                <ConsultantsFilters ref={consultantsFiltersRef}/>
            </Stack>
            <CardBody>
                <Table
                    disableTotalCounter
                    data={consultantsUIProps.consultants}
                    columns={consultantsColumns()}
                    sort={defaultSorted}
                    onChange={consultantsUIProps.setQueryParams}
                    isLoading={consultantsUIProps.isLoading}
                    total={totalConsultants}
                    pagination={{
                        sizePerPage: consultantsUIProps.queryParams.pageSize,
                        page: consultantsUIProps.queryParams.pageNumber,
                    }}
                />
            </CardBody>

        </>
    );
}

const mapStateToProps = ({ auth: { user } }) => ({
    user,
});

export default connect(mapStateToProps)(ConsultantsTable);
